const topics = [
  {
    title: '古装仙侠剧场',
    desc: '热门古装仙侠剧集一网打尽，从经典到最新热播，高清全集随时畅享',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20drama%20scene%20with%20flowing%20silk%20costumes%20in%20ancient%20celestial%20palace%2C%20soft%20mist%2C%20warm%20golden%20and%20jade%20tones%2C%20cinematic%20composition%2C%20dreamlike%20atmosphere%2C%20high%20quality%20editorial%20art&width=800&height=500&seq=carousel-xianxia-01&orientation=landscape',
    tag: '热门专题',
  },
  {
    title: '都市情感精选',
    desc: '质感都市情感剧集，讲述现代人的爱情、职场与生活，真实动人',
    img: 'https://readdy.ai/api/search-image?query=Modern%20urban%20cityscape%20at%20sunset%20with%20warm%20golden%20light%2C%20contemporary%20Chinese%20drama%20aesthetic%2C%20city%20skyline%20silhouette%2C%20cinematic%20mood%2C%20romantic%20atmosphere%2C%20soft%20bokeh%20lights&width=800&height=500&seq=carousel-urban-02&orientation=landscape',
    tag: '热门专题',
  },
  {
    title: '悬疑推理专场',
    desc: '烧脑悬疑剧集合集，紧张刺激的剧情让你欲罢不能，一口气追到底',
    img: 'https://readdy.ai/api/search-image?query=Dark%20film%20noir%20atmosphere%20with%20dramatic%20shadows%20and%20warm%20amber%20lighting%2C%20mysterious%20urban%20alleyway%20at%20night%2C%20cinematic%20thriller%20aesthetic%2C%20foggy%20street%20scene%2C%20suspenseful%20mood&width=800&height=500&seq=carousel-suspense-03&orientation=landscape',
    tag: '热门专题',
  },
  {
    title: '热门综艺合集',
    desc: '口碑综艺节目大合集，从音乐竞演到真人秀，放松解压不二之选',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20variety%20show%20stage%20with%20dynamic%20lighting%20effects%2C%20entertainment%20studio%20set%20with%20vibrant%20colors%2C%20music%20performance%20atmosphere%2C%20exciting%20live%20show%20vibe&width=800&height=500&seq=carousel-variety-04&orientation=landscape',
    tag: '热门专题',
  },
  {
    title: '经典老剧重温',
    desc: '那些年的经典电视剧，百看不厌的国民记忆，高清修复画质重温感动',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20Chinese%20living%20room%20with%20old%20TV%20set%2C%20warm%20retro%20lighting%2C%20family%20gathering%20atmosphere%2C%20classic%20drama%20nostalgia%2C%20soft%20golden%20hour%20light%20through%20window&width=800&height=500&seq=carousel-classic-05&orientation=landscape',
    tag: '热门专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-star-line"></i>
            专题策划
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精选专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">精心策划的剧集专题，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {topics.map((topic) => (
            <div
              key={topic.title}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={topic.img}
                  alt={topic.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-600 mb-2">
                  {topic.tag}
                </span>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">{topic.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{topic.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}